import { render, staticRenderFns } from "./HalamanTable.vue?vue&type=template&id=01b2e360&"
import script from "./HalamanTable.vue?vue&type=script&lang=js&"
export * from "./HalamanTable.vue?vue&type=script&lang=js&"
import style0 from "./HalamanTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports